import Vue from 'vue';
import * as t from './types';

export default {
  [t.SET_NAVIGATION]: (state, b) => {
    if (!b) {
      state.privacyPolicyPop = false;
    }
    state.navigation = b;
  },
  [t.SET_READYACTION]: (state, b) => {
    state.readyAction = b;
  },
  [t.SET_LNB_COPY]: (state, s) => {
    state.lnbCopy = s;
  },
  [t.SET_PRIVACY_POLICY_POP]: (state, b) => {
    state.privacyPolicyPop = b;
  },
  [t.SET_INTRO]: (state, b) => {
    Vue.set(state, 'introVal', b);
  },
  [t.SET_START_PROJECT_POP]: (state, b) => {
    if (b) {
      state.navigation = false;
      state.recruitPop = false;
      state.pdsPop = false;
      state.culturePop = false;
      state.privacyPolicyPop = false;
    }
    state.startProjectPop = b;
  },
  [t.SET_RECRUIT_POP]: (state, b) => {
    if (b) {
      state.navigation = false;
      state.startProjectPop = false;
      state.pdsPop = false;
      state.culturePop = false;
      state.privacyPolicyPop = false;
    }
    state.recruitPop = b;
  },
  [t.SET_PDS_POP]: (state, b) => {
    if (b) {
      state.navigation = false;
      state.startProjectPop = false;
      state.recruitPop = false;
      state.culturePop = false;
    }
    state.pdsPop = b;
  },
  [t.SET_CULTURE_POP]: (state, b) => {
    if (b) {
      state.navigation = false;
      state.startProjectPop = false;
      state.recruitPop = false;
      state.pdsPop = false;
    }
    state.culturePop = b;
  },
  [t.SET_AWARDS_POP]: (state, b) => {
    if (b) {
      state.navigation = false;
    }
    state.awardsPop = b;
  },
  [t.GET_WEATHER_PENDING]: state => {
    state.weather = '';
  },
  [t.GET_WEATHER_SUCCESS]: (state, { result }) => {
    console.log(result);
    state.weather = result;
  },
  [t.GET_WEATHER_FAIL]: state => {
    state.weather = false;
  },
  [t.GET_ADRESS_PENDING]: state => {
    state.adress = '';
  },
  [t.GET_ADRESS_SUCCESS]: (state, { result }) => {
    console.log(result);
    state.adress = result;
  },
  [t.GET_ADRESS_FAIL]: state => {
    state.adress = false;
  },
  [t.SET_PDS_LNB]: (state, payload) => {
    state.pdsLnb = payload;
  },
  [t.SET_PREV_TIT]: (state, payload) => {
    state.prevTit = payload;
  },
  [t.SET_LOADING]: (state, payload) => {
    state.loading = payload;
  }
};
